import {stopPropagationEvent} from '../../../common/shared/utils/stopPropagationEvent.function';
import {twMerge} from '../../../common/twMerge';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {ViewerEndSeriesInfoProps} from './ViewerEndSeriesInfoProps.interface';

export function ViewerEndSeriesInfo({
  contentTitle,
  onClickContentTitle,
  authorName,
  isLikeSeries,
  onClickLikeSeries,
  isAlarmOnSeries,
  onClickAlarmOnSeries,
  hasShareButton,
  isTalkViewer,
  onClickShareSeries,
  isSaleStateStop = false,
  isMobile,
  className,
  ...props
}: ViewerEndSeriesInfoProps) {
  return (
    <div
      className={twMerge('flex justify-between space-x-16pxr', className)}
      {...props}
    >
      <div className="w-full">
        {isMobile && (
          <div className="relative z-10 inline-flex items-baseline">
            <Text className="font-medium1-bold text-theme-solid-100 line-clamp-2 break-word-anywhere">
              {contentTitle}
            </Text>
          </div>
        )}
        {!isMobile && (
          <div
            className="relative z-10 inline-flex cursor-pointer items-baseline"
            onClick={e => {
              stopPropagationEvent(e);
              onClickContentTitle(e);
            }}
          >
            <Text className="font-medium1-bold text-theme-solid-100 line-clamp-2 break-word-anywhere">
              {contentTitle}
            </Text>
            <Icon
              type={IconType.ButtonArrowRight}
              className="ml-2pxr"
              disableActiveEffect
            />
          </div>
        )}
        <div className="mt-4pxr flex items-center">
          <Text className="font-small1 text-theme-solid-60 line-clamp-1">
            {authorName}
          </Text>
        </div>
      </div>
      <div className="flex w-104pxr shrink-0 items-center justify-end space-x-16pxr">
        {(!isSaleStateStop || isLikeSeries) && (
          <Icon
            className="relative z-10 h-24pxr w-24pxr cursor-pointer"
            onClick={e => {
              stopPropagationEvent(e);
              onClickLikeSeries(e);
            }}
            type={
              isLikeSeries
                ? IconType.NavigationHeartOn
                : IconType.NavigationHeartOff
            }
            {...putTiaraObjectProps({
              click: {
                copy: isLikeSeries ? 'off' : 'on',
              },
            })}
          />
        )}
        {isLikeSeries && (!isSaleStateStop || isAlarmOnSeries) && (
          <Icon
            onClick={e => {
              stopPropagationEvent(e);
              onClickAlarmOnSeries(e);
            }}
            className="relative z-10 h-24pxr w-24pxr cursor-pointer"
            type={
              isAlarmOnSeries
                ? IconType.NavigationAlarmOn
                : IconType.NavigationAlarmOff
            }
            {...putTiaraObjectProps({
              click: {
                copy: isAlarmOnSeries ? 'off' : 'on',
              },
            })}
          />
        )}
        {isTalkViewer && hasShareButton && !isSaleStateStop && (
          <Icon
            onClick={e => {
              stopPropagationEvent(e);
              onClickShareSeries(e);
            }}
            className="relative z-10 h-24pxr w-24pxr cursor-pointer"
            type={IconType.ButtonShare}
          />
        )}
      </div>
    </div>
  );
}
